import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ActionType } from 'typesafe-actions'
import { NAMESPACE } from './constants'

export type InvoicePDFRequest = { invoiceId: string; invoiceNumber: string }
export type InvoicePDFRequestAction = PayloadAction<InvoicePDFRequest, string>
export type InvoicePDFResponse = { pdfBase64: string }
export type InvoicePDFSuccessAction = PayloadAction<InvoicePDFResponse, string>

/**
 * This slice mints action creators only — its reducer is deliberately not registered in
 * `modules/api/reducer.ts` because the PDF is streamed straight to the browser and nothing
 * about it is worth keeping in the store.
 */
const emailApiSlice = createSlice({
  name: NAMESPACE,
  initialState: {},
  reducers: {
    invoicePdf_request: (state, action: PayloadAction<InvoicePDFRequest>) => {},
    invoicePdf_success: (state, { payload }: PayloadAction<InvoicePDFResponse>) => {},
  },
})

const { actions: emailApiEvents } = emailApiSlice

export type EmailEvent = ActionType<typeof emailApiEvents>

export { emailApiEvents }
